import { render, staticRenderFns } from "./SectionInfo.vue?vue&type=template&id=547ef784&"
import script from "./SectionInfo.vue?vue&type=script&lang=js&"
export * from "./SectionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports